import React, { useEffect, useState } from "react";
import { useAuthContext } from "../../hooks/useAuthContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ApiConnectionString } from "../../constants/ApiConntection";
import NoImagePlaceHolder from "../../assets/NoImagePlaceholder.png";

export default function ClubPortals() {
  const [clubs, setClubs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { user, dispatch } = useAuthContext();
  const navi = useNavigate();



  useEffect(() => {
    window.scrollTo(0, 0);
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }, 3000);
    }

    return () => clearTimeout(timeout);
  }, [user]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const clubsResponse = await axios.get(
        `${ApiConnectionString}/api/Clubs/BillingPortals`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (clubsResponse.status === 200) {
        setClubs(clubsResponse.data);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error("Error fetching clubs:", error);
    } finally {
      setIsLoading(false);
    }
  };

   const billingPortal = async (id) => {
     try {
       setIsLoading(true);
   
       const billingPortalResponse = await axios.get(
         `${ApiConnectionString}/api/ConnectBillingPortal/${id}`,
         {
           headers: { Authorization: `Bearer ${user.token}` },
         }
       );
   
       if (billingPortalResponse.status === 200) {
         window.location.href = billingPortalResponse.data;
       }
     } catch (error) {
       console.error("Failed to open billing portal:", error);
     } finally {
       setIsLoading(false);
     }
   };
   

  return (
    <div>
      <p>
        You can manage your saved cards, subscriptions, and billing details
        through your Stripe billing portal.
      </p>
      {clubs.map((club) => (
        <div key={club.id} className="d-flex justify-content-center">
          <div className="bg-white profileBox rounded shadow position-relative pb-1 mt-2">
            <div className="d-flex justify-content-center">
              <img
                src={
                  club.hasImage
                    ? `${ApiConnectionString}/api/ClubProfileImage/${club.id}`
                    : NoImagePlaceHolder
                }
                alt="Profile Image"
                width={200}
                className="m-3 circle-crop"
              />
            </div>
  
            <div className="d-flex justify-content-end align-items-center p-3">
              <p className="red-text profileUserName me-3">{club.name}</p>
              <button onClick={() => billingPortal(club.id)} className="saveChanges-button">Manage Billing</button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
  
}
